import LocalizedString from './LocalizedString';
import QualityMentoringFormQuestion from './QualityMentoringFormQuestion';
import QuestionGroup from './QuestionGroup';
import SubmissionInterface from './submission/SubmissionInterface';
import QuestionDisplayPolicy from '../QuestionDisplayPolicy';
import getPercentComplete, { getAnswerable, getAnswered, getSnapshot, getUnanswered } from '../FormUtils';

export default class QualityMentoringFormPage {
  public readonly id: number;

  public readonly name: LocalizedString;

  public readonly groups: QuestionGroup[] = [];

  public readonly questions: QualityMentoringFormQuestion[] = [];

  public nextUnansweredQuestionIdString: string;

  public percentComplete: number = 0;

  constructor(row: any) {
    this.id = row.id;
    this.name = new LocalizedString(row.name);

    row.groups?.forEach((groupRow) => {
      const group = QuestionGroup.createFromRow(groupRow);
      groupRow.questions?.forEach((questionRow) => {
        questionRow.parentId = this.id;
        const question = QualityMentoringFormQuestion.createFromRow(questionRow);
        this.questions.push(question);
        group.questions.push(question);
      });
      this.groups.push(group);
    });
  }

  setNextUnansweredQuestionIdString(submission: SubmissionInterface) {
    const nextUnansweredQuestion = this.getNextVisibleUnansweredQuestion(submission);
    this.nextUnansweredQuestionIdString = nextUnansweredQuestion?.idString || '';
  }

  getNextVisibleUnansweredQuestion(submission): QualityMentoringFormQuestion {
    const visible = this.questions.filter((question: QualityMentoringFormQuestion) => {
      return (new QuestionDisplayPolicy)
        .setBranch('root')
        .setQuestion(question)
        .setStartingQuestion(1)
        .setSubmission(submission)
        .apply();
    });
    const unanswered = getUnanswered(this.questions, submission, true);
    let nextUnanswered = null;
    visible.some((question) => {
      if (unanswered.some((q) => q.id === question.id)) {
        nextUnanswered = question;
        return true;
      }
      return false;
    });
    return nextUnanswered;
  }

  isLastAnsweredQuestion(question: QualityMentoringFormQuestion, submission) {
    const answered = getAnswered(this.questions, submission);
    const lastAnswered = answered.pop();
    return lastAnswered === question;
  }

  updateMetrics(submission, snapshotQuestions, pageNumber) {
    this.percentComplete = getPercentComplete(this.questions, submission, snapshotQuestions, pageNumber);
  }
}
